/**
 * @generated SignedSource<<17bee665f7f855041b863e43eeff528f>>
 * @relayHash 5d65a078c98a88f9d078ef57402014fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6324cf885dd4b5cbdc8892c6ad1f367a6c75bd870b64d49e6738c381913336b8

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HomeRecentsListQuery$variables = {
  actors?: ReadonlyArray<string> | null;
  collabContextId?: string | null;
  first?: number | null;
  hasActor: boolean;
  isWorkedOn: boolean;
  rootContainerIds?: ReadonlyArray<string> | null;
};
export type HomeRecentsListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomeRecentsList">;
};
export type HomeRecentsListQuery = {
  response: HomeRecentsListQuery$data;
  variables: HomeRecentsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actors"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collabContextId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasActor"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isWorkedOn"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rootContainerIds"
},
v6 = {
  "kind": "Variable",
  "name": "actors",
  "variableName": "actors"
},
v7 = {
  "kind": "Variable",
  "name": "collabContextId",
  "variableName": "collabContextId"
},
v8 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v9 = {
  "kind": "Variable",
  "name": "rootContainerIds",
  "variableName": "rootContainerIds"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "kind": "ScalarField",
  "name": "picture"
},
v15 = {
  "kind": "ScalarField",
  "name": "label"
},
v16 = {
  "concreteType": "AssetsLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "web"
    }
  ]
},
v17 = [
  {
    "kind": "ScalarField",
    "name": "url48"
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v19 = {
  "concreteType": "AssetsSchema",
  "kind": "LinkedField",
  "name": "schema",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v10/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "displayTypename"
},
v21 = {
  "alias": "filterName",
  "kind": "ScalarField",
  "name": "name"
},
v22 = {
  "kind": "ScalarField",
  "name": "url"
},
v23 = {
  "alias": "filterNameRequired",
  "kind": "ScalarField",
  "name": "name"
},
v24 = {
  "kind": "ScalarField",
  "name": "title"
},
v25 = {
  "kind": "ScalarField",
  "name": "webUi"
},
v26 = {
  "kind": "ScalarField",
  "name": "base"
},
v27 = [
  (v25/*: any*/),
  (v26/*: any*/)
],
v28 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    {
      "concreteType": "ConfluenceSpaceLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v27/*: any*/)
    },
    (v10/*: any*/)
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v30 = {
  "kind": "ScalarField",
  "name": "value"
},
v31 = [
  (v30/*: any*/)
],
v32 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiPublished",
      "plural": false,
      "selections": (v31/*: any*/)
    }
  ]
},
v33 = {
  "alias": "filterName",
  "kind": "ScalarField",
  "name": "title"
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v24/*: any*/),
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v27/*: any*/)
    },
    (v28/*: any*/),
    (v29/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/)
  ],
  "type": "ConfluenceBlogPost"
},
v35 = {
  "concreteType": "ConfluenceContentVersion",
  "kind": "LinkedField",
  "name": "latestVersion",
  "plural": false,
  "selections": [
    (v29/*: any*/)
  ]
},
v36 = [
  (v26/*: any*/),
  (v25/*: any*/)
],
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v24/*: any*/),
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v27/*: any*/)
    },
    (v28/*: any*/),
    (v29/*: any*/),
    (v32/*: any*/),
    {
      "kind": "ScalarField",
      "name": "subtype"
    },
    (v33/*: any*/)
  ],
  "type": "ConfluencePage"
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v24/*: any*/),
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v27/*: any*/)
    },
    (v35/*: any*/),
    (v28/*: any*/),
    (v33/*: any*/)
  ],
  "type": "ConfluenceWhiteboard"
},
v39 = {
  "kind": "ScalarField",
  "name": "thirdPartyId"
},
v40 = {
  "kind": "ScalarField",
  "name": "category"
},
v41 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v42 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v43 = [
  (v10/*: any*/)
],
v44 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": [
      (v13/*: any*/),
      (v14/*: any*/),
      (v10/*: any*/)
    ]
  },
  {
    "args": (v41/*: any*/),
    "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
    "kind": "LinkedField",
    "name": "linkedUsers",
    "plural": false,
    "selections": [
      {
        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v12/*: any*/),
                  (v42/*: any*/),
                  (v10/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              },
              {
                "kind": "InlineFragment",
                "selections": (v43/*: any*/),
                "type": "AppUser"
              },
              {
                "kind": "InlineFragment",
                "selections": (v43/*: any*/),
                "type": "CustomerUser"
              }
            ]
          },
          (v10/*: any*/)
        ]
      }
    ],
    "storageKey": "linkedUsers(first:1)"
  }
],
v45 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v44/*: any*/)
},
v46 = {
  "alias": "filterName",
  "kind": "ScalarField",
  "name": "displayName"
},
v47 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v13/*: any*/),
    (v42/*: any*/),
    (v10/*: any*/)
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v49 = [
  {
    "kind": "ScalarField",
    "name": "summary"
  },
  {
    "kind": "ScalarField",
    "name": "key"
  },
  {
    "concreteType": "JiraDateTimePickerField",
    "kind": "LinkedField",
    "name": "updatedField",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "dateTime"
      },
      (v10/*: any*/)
    ]
  },
  {
    "concreteType": "JiraStatusField",
    "kind": "LinkedField",
    "name": "statusField",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "mercuryName"
              },
              (v10/*: any*/)
            ]
          },
          (v10/*: any*/)
        ]
      },
      (v10/*: any*/)
    ]
  },
  (v10/*: any*/),
  (v48/*: any*/),
  {
    "concreteType": "JiraIssueTypeField",
    "kind": "LinkedField",
    "name": "issueTypeField",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "issueType",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "small"
              }
            ]
          },
          (v10/*: any*/)
        ]
      },
      (v10/*: any*/)
    ]
  },
  {
    "concreteType": "JiraProjectField",
    "kind": "LinkedField",
    "name": "projectField",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v48/*: any*/),
          (v10/*: any*/)
        ]
      },
      (v10/*: any*/)
    ]
  },
  {
    "alias": "filterName",
    "kind": "ScalarField",
    "name": "summary"
  }
],
v50 = [
  {
    "kind": "ScalarField",
    "name": "creationDate"
  },
  {
    "kind": "ScalarField",
    "name": "editDate"
  },
  (v10/*: any*/)
],
v51 = {
  "kind": "ScalarField",
  "name": "iconData"
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v13/*: any*/),
    (v22/*: any*/),
    {
      "alias": "goalCreationDate",
      "kind": "ScalarField",
      "name": "creationDate"
    },
    {
      "alias": "goalUpdates",
      "args": (v41/*: any*/),
      "concreteType": "TownsquareGoalUpdateConnection",
      "kind": "LinkedField",
      "name": "updates",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareGoalUpdateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TownsquareGoalUpdate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v50/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "updates(first:1)"
    },
    {
      "alias": "goalStatus",
      "concreteType": "TownsquareStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        {
          "kind": "ScalarField",
          "name": "score"
        }
      ]
    },
    (v51/*: any*/),
    (v47/*: any*/),
    (v23/*: any*/)
  ],
  "type": "TownsquareGoal"
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v13/*: any*/),
    (v22/*: any*/),
    {
      "alias": "projectCreationDate",
      "kind": "ScalarField",
      "name": "creationDate"
    },
    {
      "alias": "projectState",
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "state",
      "plural": false,
      "selections": (v31/*: any*/)
    },
    {
      "alias": "projectUpdates",
      "args": (v41/*: any*/),
      "concreteType": "TownsquareProjectUpdateConnection",
      "kind": "LinkedField",
      "name": "updates",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareProjectUpdateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TownsquareProjectUpdate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v50/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "updates(first:1)"
    },
    (v51/*: any*/),
    (v47/*: any*/),
    (v23/*: any*/)
  ],
  "type": "TownsquareProject"
},
v54 = {
  "kind": "InlineFragment",
  "selections": (v43/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v55 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v36/*: any*/)
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v11/*: any*/),
      {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isConfluenceCommentContainer"
      },
      (v34/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v54/*: any*/)
    ]
  }
],
v56 = [
  (v48/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": (v49/*: any*/)
  }
],
v57 = [
  {
    "concreteType": "ActivityItemEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "ActivityNode",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "concreteType": "ActivityEvent",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "timestamp"
              },
              (v10/*: any*/)
            ]
          },
          {
            "concreteType": "ActivityObject",
            "kind": "LinkedField",
            "name": "object",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "rootContainerId"
              },
              {
                "concreteType": "ActivityContributor",
                "kind": "LinkedField",
                "name": "contributors",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "concreteType": "AssetsAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": (v17/*: any*/)
                      },
                      {
                        "concreteType": "AssetsObjectType",
                        "kind": "LinkedField",
                        "name": "objectType",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      (v20/*: any*/),
                      {
                        "alias": "filterName",
                        "kind": "ScalarField",
                        "name": "label"
                      }
                    ],
                    "type": "AssetsObject"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": "assetsObjectTypeName",
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v16/*: any*/),
                      {
                        "concreteType": "AssetsIcon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": (v17/*: any*/)
                      },
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ],
                    "type": "AssetsObjectType"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": "assetsSchemaName",
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v16/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ],
                    "type": "AssetsSchema"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v13/*: any*/),
                      (v22/*: any*/),
                      {
                        "concreteType": "CompassComponentTypeObject",
                        "kind": "LinkedField",
                        "name": "typeMetadata",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "iconUrl"
                          },
                          (v13/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      (v23/*: any*/)
                    ],
                    "type": "CompassComponent"
                  },
                  (v34/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v24/*: any*/),
                      {
                        "concreteType": "ConfluenceDatabaseLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": (v27/*: any*/)
                      },
                      (v35/*: any*/),
                      (v28/*: any*/),
                      (v33/*: any*/)
                    ],
                    "type": "ConfluenceDatabase"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v24/*: any*/),
                      {
                        "concreteType": "ConfluenceEmbedLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": (v36/*: any*/)
                      },
                      {
                        "concreteType": "ConfluenceSpace",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      (v33/*: any*/)
                    ],
                    "type": "ConfluenceEmbed"
                  },
                  (v37/*: any*/),
                  (v38/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v39/*: any*/),
                      (v18/*: any*/),
                      (v22/*: any*/),
                      {
                        "concreteType": "ExternalDocumentType",
                        "kind": "LinkedField",
                        "name": "type",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/)
                        ]
                      },
                      (v45/*: any*/),
                      (v46/*: any*/)
                    ],
                    "type": "ExternalDocument"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v39/*: any*/),
                      (v18/*: any*/),
                      (v22/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastUpdate"
                      },
                      {
                        "concreteType": "ExternalUser",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": (v44/*: any*/)
                      },
                      {
                        "concreteType": "ExternalReviewer",
                        "kind": "LinkedField",
                        "name": "reviewers",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "approvalStatus"
                          },
                          {
                            "concreteType": "ExternalUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v44/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "ExternalProvider",
                        "kind": "LinkedField",
                        "name": "provider",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/)
                        ]
                      },
                      (v46/*: any*/)
                    ],
                    "type": "ExternalPullRequest"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v39/*: any*/),
                      (v18/*: any*/),
                      (v22/*: any*/),
                      (v45/*: any*/),
                      (v40/*: any*/),
                      {
                        "alias": "externalLinkStatus",
                        "concreteType": "ExternalRemoteLinkStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appearance"
                          }
                        ]
                      },
                      (v46/*: any*/)
                    ],
                    "type": "ExternalRemoteLink"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v39/*: any*/),
                      (v18/*: any*/),
                      (v22/*: any*/),
                      {
                        "alias": "workItemStatus",
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      (v46/*: any*/)
                    ],
                    "type": "ExternalWorkItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v13/*: any*/),
                      (v22/*: any*/),
                      {
                        "concreteType": "MercuryFocusArea",
                        "kind": "LinkedField",
                        "name": "parent",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v13/*: any*/),
                          (v22/*: any*/)
                        ]
                      },
                      {
                        "alias": "focusAreaIcon",
                        "concreteType": "MercuryFocusAreaIcon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "createdDate"
                      },
                      (v47/*: any*/),
                      (v23/*: any*/)
                    ],
                    "type": "MercuryFocusArea"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v13/*: any*/),
                      (v22/*: any*/),
                      (v15/*: any*/),
                      (v23/*: any*/)
                    ],
                    "type": "MercuryPortfolio"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v49/*: any*/),
                    "type": "JiraIssue"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": "loomVideoUrl",
                        "kind": "ScalarField",
                        "name": "url"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updatedAt"
                      },
                      (v47/*: any*/),
                      (v23/*: any*/)
                    ],
                    "type": "LoomVideo"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "concreteType": "RadarWorker",
                        "kind": "LinkedField",
                        "name": "worker",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "preferredName"
                          },
                          (v10/*: any*/),
                          {
                            "alias": "filterName",
                            "kind": "ScalarField",
                            "name": "preferredName"
                          }
                        ]
                      },
                      (v22/*: any*/)
                    ],
                    "type": "RadarPosition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "viewName"
                      },
                      (v22/*: any*/),
                      {
                        "alias": "filterNameRequired",
                        "kind": "ScalarField",
                        "name": "viewName"
                      }
                    ],
                    "type": "RadarView"
                  },
                  (v52/*: any*/),
                  (v53/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "container",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isTownsquareCommentContainer"
                          }
                        ]
                      }
                    ],
                    "type": "TownsquareComment"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v55/*: any*/),
                    "type": "ConfluenceInlineComment"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v55/*: any*/),
                    "type": "ConfluenceFooterComment"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v56/*: any*/),
                    "type": "JiraPlatformComment"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v56/*: any*/),
                    "type": "JiraServiceManagementComment"
                  },
                  (v54/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v43/*: any*/),
                    "type": "DevOpsPullRequestDetails"
                  }
                ]
              }
            ]
          },
          (v10/*: any*/)
        ]
      }
    ]
  }
],
v58 = [
  {
    "fields": [
      (v7/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeRecentsListQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "hasActor",
            "variableName": "hasActor"
          },
          {
            "kind": "Variable",
            "name": "isWorkedOn",
            "variableName": "isWorkedOn"
          },
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "HomeRecentsList"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeRecentsListQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "condition": "hasActor",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "fields": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v9/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  (v8/*: any*/)
                ],
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "workedOn",
                "plural": false,
                "selections": (v57/*: any*/)
              }
            ]
          },
          {
            "condition": "hasActor",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "concreteType": "MyActivity",
                "kind": "LinkedField",
                "name": "myActivity",
                "plural": false,
                "selections": [
                  {
                    "condition": "isWorkedOn",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": (v58/*: any*/),
                        "concreteType": "ActivityConnection",
                        "kind": "LinkedField",
                        "name": "workedOn",
                        "plural": false,
                        "selections": (v57/*: any*/)
                      }
                    ]
                  },
                  {
                    "condition": "isWorkedOn",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "args": (v58/*: any*/),
                        "concreteType": "ActivityConnection",
                        "kind": "LinkedField",
                        "name": "viewed",
                        "plural": false,
                        "selections": (v57/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6324cf885dd4b5cbdc8892c6ad1f367a6c75bd870b64d49e6738c381913336b8",
    "metadata": {},
    "name": "HomeRecentsListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "98079ae860decdc11135c033c5b25eb8";

export default node;
